export const canada = {
  slug: "canada",
  name: "Canada",
  flag: "🇨🇦",
  tagline: "Study, Work & Settle — The Complete Package",
  heroImg: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#C0392B",
  students: "120+",
  avgTuition: "CAD $15,000–$35,000/yr",
  avgLiving: "CAD $1,200–$2,000/mo",
  workPermit: "3 years post-study (PGWP)",
  ieltsReq: "6.0–7.0",
  intakeMonths: ["September", "January", "May"],
  overview:
    "Canada is the most immigrant-friendly study destination. The Post-Graduate Work Permit (PGWP) gives up to 3 years of open work authorization, and Express Entry makes PR realistic within 2–3 years of graduating. Three intakes per year offer maximum flexibility.",
  whyChoose: [
    { icon: "🏠", title: "Clear PR Pathway", desc: "Express Entry, PNP, and Atlantic Immigration streams — Canada actively wants international graduates to stay." },
    { icon: "🧑‍💼", title: "3-Year Work Permit", desc: "PGWP matches your study duration — up to 3 years of open work authorization post-graduation." },
    { icon: "🌿", title: "Safe & Multicultural", desc: "One of the safest countries for international students with the world's largest Indian diaspora network." },
    { icon: "💰", title: "Part-Time Work Rights", desc: "Work 24 hours/week during studies — offset living costs while gaining Canadian work experience." },
    { icon: "🎯", title: "3 Intakes Per Year", desc: "September, January, and May intakes give you maximum flexibility in planning your timeline." },
    { icon: "🏔️", title: "Quality of Life", desc: "Consistently top-ranked for quality of life — clean cities, universal healthcare, and natural beauty." },
  ],
  process: [
    { step: "01", title: "College / University Selection", desc: "We identify DLI-designated institutions and programs that maximize PGWP eligibility." },
    { step: "02", title: "Application & Offer Letter", desc: "Statement of Purpose, academic transcripts, and reference letters — prepared to Canadian standards." },
    { step: "03", title: "Study Permit Application", desc: "We manage IRCC portal applications, biometrics, GIC (Guaranteed Investment Certificate), and PAL if required." },
    { step: "04", title: "Pre-Departure & Arrival", desc: "SIN number, province health card, banking — complete checklist so you land running." },
  ],
  universities: [
    "university-of-toronto", "mcgill-university", "ubc", "university-of-waterloo",
    "university-of-alberta", "mcmaster-university", "university-of-calgary", "queens-university",
    "western-university", "york-university", "university-of-ottawa", "dalhousie-university",
    "university-of-victoria", "simon-fraser", "university-of-manitoba", "university-of-saskatchewan",
    "university-of-new-brunswick", "memorial-university", "carleton-university", "concordia-university",
    "universite-de-montreal", "laval-university", "ryerson-university", "brock-university",
    "guelph-university",
  ],
  stats: [
    { n: "120+", label: "Students Placed" },
    { n: "3yr",  label: "Work Permit" },
    { n: "97%",  label: "Visa Success" },
    { n: "3",    label: "Intakes/Year" },
  ],
};
